<template lang="pug">
  b-container#publisher-container
    b-card(no-body, style="width:100%;")
      b-table.card-table.mb-0(:items="parsed_posts", :fields="fields", responsive, show-empty, selectable, select-mode="single",  selectedVariant="primary", @row-selected="rowSelected", :filter="filter")
        template(v-slot:empty)
          p.text-help.mb-0 No hay publicaciones
        template(v-slot:cell(media_url)="data")
          b-img.img(rounded, width="50px", height="50px", :src="data.item.media_url", v-if="data.item.media_url")
        template(v-slot:cell(link)="data")
          b-link(:href="data.item.link", target="blank", v-if="data.item.external_id") Ver en Facebook
          p(v-else) {{data.item.link}}
        template(v-slot:cell(actions)="data")
          trash-2-icon.icon-md.hover-danger.pointer(v-b-tooltip.hover="'Eliminar'", @click.stop="destroyPost(data.item)")
      b-pagination.mt-2(v-model="pagination_page", align="center", v-if="pagination_hasNextPage", :total-rows="100", :per-page="pagination_limit", :limit="3" @change="getPublicMedia")
</template>

<script>
  import { createNamespacedHelpers, mapActions } from 'vuex'
  const instagramController = createNamespacedHelpers('instagram')
  const public_mediaController = createNamespacedHelpers('public_media')
  import Avatar from '../../../components/Avatar.vue'
  import ImgInput from '../../../components/img-input'
  import { UploadFile } from '../../../helpers/upload-file'

  export default {
    data () {
      return {
        loading: false,
        filter: null,
        fields: [
          {
            key: 'public_media_id',
            label: 'ID'
          },
          {
            key: 'text',
            label: 'Publicación',
            //tdClass: 'post-text'
          },
          {
            key: 'media_url',
            label: 'Imagen'
          },
          {
            key: 'update_date',
            label: 'Ultima Actualización'
          },
          {
            key: 'actions',
            label: 'Acciones'
          }
        ],
      }
    },
    computed: {
      ...public_mediaController.mapState({
        public_media: state => state.public_media
      }),
      parsed_posts () {
        let self = this
        return this.public_media.map(p => {
          p.update_date = self.$moment(p.updatedAt).locale('es').format('DD [de] MMMM [del] YYYY, HH:mm a')
          return p
        })
      },
    },
    methods: {
      ...mapActions(['public_media/list', ]),
      getPublicMedia () {
        let self = this
        // this.showLoadingScreen()

        this['public_media/list']({
          account_id: self.$route.params.account_id,
          params: {
            platform: 'instagram',
            ...self.paginationParams,
          },
          callback: res => {
            self.hideLoadingScreen()
            if (res.error) {
              self.$message.error(res.error)
            } else {
              self.parseResponseForPaginationData(res)
            }
          }
        })
      },
      getPost (row, getAll = true) {
        let self = this
        this.$scrollTo('#router-container', 500, {
          container: '#router-container',
          force: true
        })

        setTimeout(() => {
          this['public_media/get']({
            ...row,
            callback: res => {
              if (res.error) {
                self.$message.error(res.error)
              } else {
                console.log(res.resource)
                self.post_data = Object.assign(self.post_data, res.resource)
                self.unsaved_changes = false
                self.syncPost()
                if (getAll) {
                  //self.getAnswers()
                  //self.getReactions()
                }
              }
            }
          })
        }, 300);
      },
      async rowSelected (items) {
        if(!items.length) return
        if(this.unsaved_changes) {
          try {
            let response = await this.$bvModal.msgBoxConfirm(`¿Deseas continuar sin guardar los cambios?`, {
              title: 'Se perderan los cambios',
              okTitle: 'Continuar',
              cancelTitle: 'Cancelar'
            })
            if(response){
              this.getPost(items[0]);
            }
          } catch (e) {
            console.error(e.message);
          }
        } else {
          this.getPost(items[0]);
        }
      },
    },
    mounted () {
      this.getPublicMedia()
    },
    components: { Avatar, ImgInput }
  }
</script>

<style lang="css" scoped>
  .absolute {
    position: absolute;
  }
</style>
